import Collapse from 'blocks.simple/collapse/collapse'
import translate from 'core/translate'
import { cn } from 'ethcss'
import React, { useState } from 'react'
import { grid } from 'theme'
import styles from '../settings.jcss'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { updateCompany } from 'blocks.app/user/user.state'
import { SwitchButton } from 'atoms/SwitchButton'
import helpers from 'core/helpers'

const SettingsContent = () => {
    const company: any = useSelector<RootStateOrAny>((state) => state.user.company)
    const dispatch = useDispatch()

    const onChangeBroadcastAdministration = (checked: boolean) => {
        dispatch(
            updateCompany({
                data: {
                    contentModeration: checked,
                },
                isSaveCompany: true,
            })
        )
    }

    return (
        <Collapse title={() => translate('content')} className={cn(styles.background, grid.mb_md)}>
            <div className={grid.row}>
                <div className={grid.mr_miniMiddle}>{translate('turnOnModeration')}</div>
                <SwitchButton
                    onChange={() => onChangeBroadcastAdministration(!company.contentModeration)}
                    checked={!!company.contentModeration}
                    disabled={!helpers.isAvailable({ key: 'moderation', action: 'update' })}
                />
            </div>
        </Collapse>
    )
}

export default SettingsContent
